import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { fetchAuthSession } from 'aws-amplify/auth';
import { RoutesPaths } from 'routes/Routes.types';

const paramsSerializer = (params: Record<string, unknown>): string => {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach(v => searchParams.append(key, String(v)));
    } else if (value !== undefined && value !== null) {
      searchParams.append(key, String(value));
    }
  });
  return searchParams.toString();
};

const baseUrl =
  !process.env.NODE_ENV || process.env.NODE_ENV === 'development'
    ? `${process.env.REACT_APP_HOSTNAME}/api/v1`
    : `${process.env.REACT_APP_HOSTNAME}/api/v1`;

export const authNoSessionSplitApi = (
  reducerPath: string,
  tagTypes?: string[],
) =>
  createApi({
    reducerPath,
    baseQuery: fetchBaseQuery({
      baseUrl,
      paramsSerializer,
    }),
    tagTypes: tagTypes || [],
    endpoints: () => ({}),
  });

export const authSplitApi = (reducerPath: string, tagTypes?: string[]) =>
  createApi({
    reducerPath,
    baseQuery: fetchBaseQuery({
      baseUrl,
      paramsSerializer,
      prepareHeaders: async headers => {
        try {
          const session = await fetchAuthSession();
          const idToken = session.tokens?.idToken?.toString();
          if (!idToken) {
            throw new Error('No active session');
          }
          headers.set('authorization', `Bearer ${idToken}`);
          headers.set('x-user-profile', 'READY_ADMIN');
        } catch (err) {
          window.location.replace(`/${RoutesPaths.LOGIN}`);
          localStorage.clear();
        }
        return headers;
      },
    }),
    tagTypes: tagTypes || [],
    endpoints: () => ({}),
  });

export const emptySplitApi = (reducerPath: string, tagTypes?: string[]) =>
  createApi({
    reducerPath,
    tagTypes: tagTypes || [],
    baseQuery: fetchBaseQuery({
      baseUrl,
      paramsSerializer,
    }),
    endpoints: () => ({}),
  });
